import { CameraOutlined, DeleteOutlined, EditOutlined } from '@vindr/icons';
import cx from '@vindr/utils/helpers/cx';
import resizeBase64Image from '@vindr/utils/resizeBlobImage';
import { Form, Space, Upload } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isURL } from '@vindr/utils/validation';
import { getImageSrc } from '@vindr/utils/helpers/common.helper';

type UploadItemProps = Parameters<typeof Form['Item']>[0] & {
  name?: string;
  form: FormInstance<any>;
  editItem?: any;
  className?: string;
  formProps?: Parameters<typeof Form['Item']>['0'];
  imageName?: string;
  [key: string]: any;
};

const UploadItem = ({
  name = 'logo',
  label,
  placeholder = 'Upload Logo',
  form,
  editItem,
  noStyle,
  className,
  formProps,
  imageName,
  ...props
}: UploadItemProps) => {
  const { t } = useTranslation('Vindoc');
  const image = Form.useWatch(name, form);

  const isURLImage = useMemo(() => isURL(image), [image]);

  useEffect(() => {
    (async () => {
      if (!isURLImage) return;
      const logo = await getImageSrc(image);
      const compressImage = await resizeBase64Image(logo, { type: 'image/png' });
      form.setFieldValue(name, compressImage);
    })();
  }, [form, isURLImage, name]);

  return (
    <Form.Item name={name} noStyle={noStyle} label={label} {...formProps}>
      <Upload
        accept="image/*"
        listType="picture-card"
        fileList={[]}
        action={image}
        customRequest={(data) => data.onSuccess('ok')}
        beforeUpload={(file) => {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const logo = e.target.result as string;
            const compressImage = await resizeBase64Image(logo, { type: file.type });
            form.setFieldValue(name, compressImage);
            imageName && form.setFieldValue(imageName, file.name);
          };
          reader.readAsDataURL(file);
        }}
        className={cx('overflow-hidden', className)}
        {...props}
        // onPreview={handlePreview}
        // onChange={(data) => console.log(data)}
      >
        {image ? (
          <div className="relative">
            <img src={image} alt={image} style={{ width: '100%' }} />
            <div
              className="overlay text-white"
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'flex',
                background: 'rgba(0,0,0,0.5)',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: 16,
                transition: 'all 0.3s',
                top: 0,
                left: 0,
              }}
            >
              <Space size="middle">
                <EditOutlined className="image-action" />
                <DeleteOutlined
                  className="image-action"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // setImage('');
                    form.setFieldsValue({ [name]: undefined, [imageName]: undefined });
                  }}
                />
              </Space>
            </div>
          </div>
        ) : (
          <div className="signature-text" style={{ opacity: 0.4 }}>
            <div style={{ marginTop: 8 }}>{t(placeholder)}</div>
            <CameraOutlined style={{ fontSize: 20 }} />
          </div>
        )}
      </Upload>
    </Form.Item>
  );
};
export default UploadItem;
